// extracted by mini-css-extract-plugin
module.exports = {"select":"Users_select__1DLdK","name":"Users_name__2kOEd","table":"Users_table__1MBbm"};